import React, { Component, ErrorInfo, ReactFragment, ReactNode } from 'react';

interface Props {
	children?: ReactNode;
}

interface State {
	error?: Error;
	hasError: boolean;
	showDetail: boolean;
}

class ErrorBoundary extends Component<Props, State> {
	public state: State = {
		error: undefined,
		hasError: false,
		showDetail: false,
	};

	public static getDerivedStateFromError(error: Error): State {
		// Update state so the next render will show the fallback UI.
		return { error: error, hasError: true, showDetail: false };
	}

	public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
		console.error('Uncaught error:', error, errorInfo);
	}

	gotoHome = (): void => {
		location.href = '/';
	};

	public render(): JSX.Element | ReactFragment | string | boolean | number | undefined | null {
		if (this.state.hasError) {
			return (
				<div className='text-center mt-4'>
					<h1>Ups! Niekde sa stala chyba</h1>
					<div className='mb-2'>
						<div>Ospravedlňujeme sa, nastala chyba, opakujte akciu neskôr.</div>
						<a
							href='#'
							onClick={() => {
								this.setState({ showDetail: !this.state.showDetail });
							}}
						>
							Viac technických detailov o chybe
						</a>
						<pre className={'text-start card p-3 ' + (this.state.showDetail ? '' : 'd-none')}>
							<div className='fw-bold'>{this.state.error?.message}</div>
							<div>{this.state.error?.stack}</div>
						</pre>
					</div>
					<button className={'btn btn-primary'} onClick={this.gotoHome}>
						Home
					</button>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
